import React from 'react';
import { Skeleton } from '@mui/material';



const SklInput = () => {


    return(
        <Skeleton animation="wave" className={` w-full max-h-[3.449rem] h-[3.449rem] rounded-xl`}></Skeleton>
    )
}

export default SklInput;